module.exports = __webpack_public_path__ + "img/logolarge.b68d4072.png";